import { render, staticRenderFns } from "./PersonSetting.vue?vue&type=template&id=2b9ade2c&scoped=true"
import script from "./PersonSetting.vue?vue&type=script&lang=js"
export * from "./PersonSetting.vue?vue&type=script&lang=js"
import style0 from "./PersonSetting.vue?vue&type=style&index=0&id=2b9ade2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ade2c",
  null
  
)

export default component.exports